import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import ExpenseReimbursementsPanel from '../components/hr/ExpenseReimbursementsPanel';
import { useAuth } from '../hooks/useAuth';

const ExpenseReimbursements = () => {
  const { isManagerOrAdmin } = useAuth();
  if (!isManagerOrAdmin()) {
    return (
      <Box>
        <Alert severity="warning">You do not have permission to review expense reimbursements.</Alert>
      </Box>
    );
  }

  return (
  <Box>
    <Typography variant="h5" component="h1" sx={{ fontWeight: 600, mb: 2 }}>
      Expense reimbursements
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
      Receipts from the Employee Portal. Approve to notify payroll, then mark Paid after reimbursement.
    </Typography>
    <ExpenseReimbursementsPanel embedded />
  </Box>
  );
};

export default ExpenseReimbursements;
